export default __webpack_public_path__ + "static/media/Google_Authenticator.b1e24502.png";